import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, CardBody, CardTitle, Button, Form, FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import RoleServices from '../services/RoleServices';
import UserServices from '../services/UserServices';

const Profil = () => {
    const [showChangePassword, setShowChangePassword] = useState(false);
    const [lastPassword, setLastPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');
    const [passwordsMatch, setPasswordsMatch] = useState(true);
    const [message, setMessage] = useState("");
    const [alert, setAlert] = useState("");
    const [profile, setProfile] = useState({
        id: null,
        first_name: '',
        username: '',
        last_name: '',
        email: "",
        role_id: "",
        phone: "",
        password: ""
    });

    const [showForm, setShowForm] = useState(false);
    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        email: '',
        phone: ''
    });
    const [roles, setRoles] = useState([]);
    const id = sessionStorage.getItem('id_user');

    const phoneRegex = /^\d+$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    console.log(id);
    useEffect(() => {
        const fetchUsers = async () => {
            const data = await UserServices.getUserProfil(id);
            console.log(data);
            setProfile(data['user']);
        };
        fetchUsers();

        const fetchRoles = async () => {
            const roles = await RoleServices.getRoles();
            console.log(roles);
            setRoles(roles);
        };
        fetchRoles();
    }, [id]);

    const showRoleTitle = (roleId) => {
        const role = roles.filter((r) => r.id === roleId);
        let element;
        if (typeof role[0] !== 'undefined') {
            element = role[0];
        } else {
            element = {
                title: " "
            }
        }
        return element.title;
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
    }

    const toggleChangeProfil = () => {
        setFormData({
            first_name: profile.first_name,
            last_name: profile.last_name,
            email: profile.email,
            phone: profile.phone
        });
        setShowChangePassword(false);
        setShowForm(true);
    };

    const EditValidateFields = () => {

        if (formData.last_name.trim() === "" || formData.last_name.length < 3) {
            setAlert("Le prénom doit avoir une longueur d'au moins 3 caractères.");
            return false;
        }

        if (formData.first_name.trim() === "" || formData.first_name.length < 3) {
            setAlert("Le nom doit avoir une longueur d'au moins 3 caractères.");
            return false;
        }

        if (formData.phone.trim() === "" || formData.phone.length !== 8) {
            setAlert("Le numéro de téléphone doit avoir une longueur de 8 caractères.");
            return false;
        }

        if (!phoneRegex.test(formData.phone)) {
            setAlert("Le numéro de téléphone ne doit contenir que des chiffres.");
            return false;
        }

        if (formData.email.trim() === "" || !emailRegex.test(formData.email)) {
            setAlert("Veuillez entrer une adresse email valide.");
            return false;
        }

        return true;
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        if (!EditValidateFields()) {
            return;
        }

        const newProfile = {
            id: profile.id,
            first_name: formData.first_name,
            last_name: formData.last_name,
            email: formData.email,
            phone: formData.phone
        };

        UserServices
            .updateUserProfil({ ...profile, ...newProfile })
            .then(data => {
                console.log(data);
                if (data['success'] === true) {
                    setFormData({
                        first_name: '',
                        last_name: '',
                        email: '',
                        phone: ''
                    });
                    setProfile({ ...profile, ...newProfile });
                    setShowForm(false);
                    setTimeout(() => {
                        setMessage(data['message']);
                    }, 2000);
                } else if (data['success'] === false) {
                    setTimeout(() => {
                        setAlert(data['message']);
                    }, 2000);

                }
            });
    }

    const toggleChangePassword = () => {
        setShowForm(false);
        setShowChangePassword(true);
    };

    const handleLastPasswordChange = (e) => {
        setLastPassword(e.target.value);
    };

    const handleNewPasswordChange = (e) => {
        setNewPassword(e.target.value);
        if (e.target.value !== confirmNewPassword) {
            setPasswordsMatch(false);
        } else {
            setPasswordsMatch(true);
        }
    };

    const handleConfirmNewPasswordChange = (e) => {
        setConfirmNewPassword(e.target.value);
        if (e.target.value !== newPassword) {
            setPasswordsMatch(false);
        } else {
            setPasswordsMatch(true);
        }
    };

    const handleSubmitChangePassword = (e) => {
        e.preventDefault();
        if (newPassword.trim() === "") {
            setAlert("Veuillez remplir tous les champs.");
            return false;
        }
        // Ajouter ici le code pour soumettre le formulaire et mettre à jour le mot de passe
        const newProfile = {
            id: profile.id,
            new_password: newPassword,
            old_password: lastPassword
        };
        UserServices
            .updateUserPassword({ ...profile, ...newProfile })
            .then(data => {
                console.log(data);
                if (data['success'] === true) {
                    setLastPassword('');
                    setNewPassword('');
                    setConfirmNewPassword('');
                    setPasswordsMatch(true);
                    setShowChangePassword(false);
                    setTimeout(() => {
                        setMessage(data['message']);
                    }, 2000); // délai de 3 secondes
                } else if (data['success'] === false) {
                    setTimeout(() => {
                        setAlert(data['message']);
                    }, 2000); // délai de 3 secondes

                }
            });
    };


    return (
        <Container className="mt-4">
            <h1 className="my-5">Profil</h1>
            <Row>
                <Col md="6">
                    <Card>
                        <CardBody>
                            {message && <div className="alert alert-success mt-1">{message}</div>}
                            {alert && <div className="alert alert-danger mt-1">{alert}</div>}
                            <p><strong>Email:</strong> {profile.email}</p>
                            <p><strong>Tél:</strong> {profile.phone}</p>
                            <p><strong>Prénom:</strong> {profile.first_name}</p>
                            <p><strong>Nom:</strong> {profile.last_name}</p>
                            <p><strong>Rôle:</strong> {showRoleTitle(profile.role_id)}</p>
                            <div className="btn-group" role="group" aria-label="Actions">
                                <button type="button" className="btn btn-primary" onClick={toggleChangeProfil}>Modifier le profil</button>
                                <button type="button" className="btn btn-info text-white" onClick={toggleChangePassword} >Modifier le mot de passe</button>
                            </div>

                            {showChangePassword && (
                                <Form className="mt-4" onSubmit={handleSubmitChangePassword}>
                                    <FormGroup>
                                        <Label for="lastPassword">Ancien mot de passe</Label>
                                        <Input type="password"
                                            name="lastPassword"
                                            id="lastPassword"
                                            value={lastPassword}
                                            onChange={handleLastPasswordChange}
                                            required={true} />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="newPassword">Nouveau mot de passe</Label>
                                        <Input type="password"
                                            name="newPassword"
                                            id="newPassword"
                                            value={newPassword}
                                            onChange={handleNewPasswordChange}
                                            required={true}
                                            invalid={!passwordsMatch} />
                                        {!passwordsMatch && <FormFeedback>Les mots de passe ne correspondent pas</FormFeedback>}
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="confirmNewPassword">Confirmer le nouveau mot de passe</Label>
                                        <Input type="password"
                                            name="confirmNewPassword"
                                            id="confirmNewPassword"
                                            value={confirmNewPassword}
                                            onChange={handleConfirmNewPasswordChange}
                                            required={true}
                                            invalid={!passwordsMatch} />
                                        {!passwordsMatch && <FormFeedback>Les mots de passe ne correspondent pas</FormFeedback>}
                                    </FormGroup>
                                    <button type="submit" className='btn btn-success'>Enregistrer</button>
                                    <button onClick={() => setShowChangePassword(false)} className="ml-2 btn btn-secondary">Annuler</button>
                                </Form>
                            )}
                            {showForm && (
                                <form onSubmit={handleSubmit} className="mt-4">
                                    <div className="mb-3">
                                        <label htmlFor="first_name" className="form-label">Prénom</label>
                                        <input type="text" name="first_name" value={formData.first_name} onChange={handleInputChange} id="first_name" className="form-control" />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="last_name" className="form-label">Nom</label>
                                        <input type="text" name="last_name" value={formData.last_name} onChange={handleInputChange} id="last_name" className="form-control" />
                                    </div >
                                    <div className="mb-3">
                                        <label htmlFor="email" className="form-label">Email</label>
                                        <input type="email" name="email" value={formData.email} onChange={handleInputChange} id="email" className="form-control" />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="phone" className="form-label">Téléphone</label>
                                        <input type="tel" name="phone" value={formData.phone} onChange={handleInputChange} id="phone" className="form-control" />
                                    </div>
                                    <div className="mb-3">
                                        <button type="submit" className="btn btn-primary">Enregistrer</button>
                                        <button onClick={() => setShowForm(false)} className="btn btn-secondary">Annuler</button>
                                    </div >
                                </form >
                            )}
                        </CardBody >
                    </Card >
                </Col >
            </Row >
        </Container >
    );
};
export default Profil;